<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar :menuInfo="menuInfo"></Toolbar>
      <div class="right">
        <Navigation :menuInfo="menuInfo"></Navigation>
        <div class="main">
          <div class="main-nav">
            <ContentsNavigation v-if="false && (menuInfo.company || menuInfo.device)" :menuInfo="menuInfo" @selectNode="selectNode"></ContentsNavigation>
          </div>
          <div class="board clear">
            <TreeView
              :treeType="treeType"
              :treeScope="treeScope"
              :refreshEvent="refreshEvent"
              @selectNode="selectNode"
            ></TreeView>

            <div class="list">
              <OrderList
                class="order-list"
                :deviceID="deviceID"
                :selectEvent="selectEvent"
                :companyID="companyID"
              ></OrderList>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
/* eslint-disable no-console */

import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';
import ContentsNavigation from '@/components/include/ContentsNavigation';
import TreeView from '@/components/include/TreeView';
import OrderList from '@/components/order/OrderList';

export default {
  components: {
    Toolbar,
    Navigation,
    ContentsNavigation,
    TreeView,
    OrderList,
  },
  data: () => ({
    menu: null,
    company: null,
    device: null,
    deviceID: '',
    selectEvent: 0,
    refreshEvent: 0,
    treeType: 'device',
    treeScope: 'biz',
    menuInfo: {
      mainTitle: 'Device',
      mainName: '재고 관리',
      subTitle: 'Order',
      subName: '발주 관리',
      company: null,
      division: null,
      device: null,
      tray: null,
      product: null,
    },
    companyID: '',
  }),
  created() {
    this.menu = this.$route.name;
  },
  methods: {
    selectNode(object, type) {
      if (type === 'company') {
        this.company = object;
        this.device = null;
        this.deviceID = '';
        this.companyID = object.id;
        this.menuInfo.company = object;
        this.menuInfo.device = null;
        this.selectEvent ^= 1;
      } else if (type === 'device') {
        this.company = null;
        this.device = object;
        this.deviceID = object.id;
        this.companyID = object.pID;
        this.menuInfo.company = null;
        this.menuInfo.device = object;
        this.selectEvent ^= 1;
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/order/Order.vue